<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>
<script>
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import enquireScreen from '@/utils/device'

  export default {
    data () {
      return {
        locale: zhCN,
      }
    },
    created () {
      let that = this
      // 检查URL中是否有重定向参数
      const hash = window.location.hash
      if (hash.includes('redirect=')) {
        // 解析重定向URL和参数
        const redirectUrl = hash.split('redirect=')[1].split('&')[0]
        // 获取其他参数
        const otherParams = hash.includes('&') ? hash.substring(hash.indexOf('&') + 1) : ''
        // 执行重定向，保留其他参数
        const targetUrl = redirectUrl + (otherParams ? '?' + otherParams : '')
        window.location.href = targetUrl
        return
      }
      
      enquireScreen(deviceType => {
        // tablet
        if (deviceType === 0) {
          that.$store.commit('TOGGLE_DEVICE', 'mobile')
          that.$store.dispatch('setSidebar', false)
        }
        // mobile
        else if (deviceType === 1) {
          that.$store.commit('TOGGLE_DEVICE', 'mobile')
          that.$store.dispatch('setSidebar', false)
        }
        else {
          that.$store.commit('TOGGLE_DEVICE', 'desktop')
          that.$store.dispatch('setSidebar', true)
        }

      })
    }
  }
</script>
<style>
  #app {
    height: 100%;
  }
</style>